import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import { getRandomNumber } from '../../../utilities/math/index.js';
import '../../../atoms/buttons/enums.js';
import { isRTL } from '../../../utilities/dom-helpers/index.js';
import { unsafeHTML as o } from '../../../../../node_modules/lit-html/directives/unsafe-html.js';

const changeButtonsStyle = (textBlock) => {
    const lightButtons = textBlock.querySelectorAll('.primary-button.style-light');
    const lightOutlinedButtons = textBlock.querySelectorAll('.primary-button.style-outlined-light');
    lightButtons.forEach(button => {
        button.classList.remove('style-light');
        button.classList.add('style-dark');
    });
    lightOutlinedButtons.forEach(button => {
        button.classList.remove('style-outlined-light');
        button.classList.add('style-outlined-dark');
    });
};
// eslint-disable-next-line no-undef
const setTextBlockClasses = (textBlocks) => {
    if (textBlocks.length) {
        textBlocks.forEach(textBlock => {
            var _a, _b;
            const textBlockShadow = textBlock.shadowRoot;
            if (!textBlockShadow)
                return;
            const textBlockContainer = textBlockShadow.querySelector('.text-block');
            if (!textBlockContainer)
                return;
            textBlockContainer.classList.add('in-accordion');
            const richTextSlot = textBlockContainer.querySelector('slot[name="rich-text"]');
            const richText = (_a = richTextSlot === null || richTextSlot === void 0 ? void 0 : richTextSlot.assignedNodes) === null || _a === void 0 ? void 0 : _a.call(richTextSlot)[0];
            (_b = richText === null || richText === void 0 ? void 0 : richText.classList) === null || _b === void 0 ? void 0 : _b.add('in-accordion');
            changeButtonsStyle(textBlock);
        });
    }
};
const renderAccordionItem = (ctx) => {
    var _a;
    const itemClassMap = {
        rtl: ctx.rtl || isRTL(),
        'highlight-active': !!ctx.highlightActiveItem,
        'small-title': !!ctx.smallTitles,
    };
    const id = `acc-content-${getRandomNumber().toString(16).slice(2)}`;
    setTimeout(() => {
        const contentSlot = ctx.renderRoot.querySelector('slot');
        if (!contentSlot)
            return;
        const content = contentSlot.assignedNodes()[0];
        if (!content)
            return;
        const textBlocks = content.querySelectorAll('text-block');
        setTextBlockClasses(textBlocks);
    }, 0);
    const titleColorClass = ctx.titleColor ? `title-color-${ctx.titleColor}` : '';
    const classes = [
        'header',
        ctx.arrowIcon ? `arrow-${ctx.arrowIcon}` : '',
        ...Object.entries(itemClassMap)
            .filter(([, value]) => value)
            .map(([key]) => key),
        ctx.dividerColor ? `divider-color-${ctx.dividerColor}` : '',
    ]
        .filter(Boolean)
        .join(' ');
    return $ `<button class="${classes}" aria-expanded="${(_a = ctx.isExpanded) !== null && _a !== void 0 ? _a : 'false'}" aria-controls="${id}" ?disabled="${ctx.isDisabled}" ?active="${!!ctx.isExpanded}" @click="${(e) => {
        ctx.handleClick(e);
    }}" @keyDown="${ctx.handleClick}"><p class="title ${titleColorClass} ${ctx.isDisabled && !ctx.isExpanded
        ? 'inactive'
        : ''}">${o(ctx.title)}</p><div class="details">${o(ctx.elementDetails)}</div><div class="icon"></div></button><div class="content" id="${id}"><div class="inner"><slot name="accordion-content"></slot></div></div>`;
};

export { renderAccordionItem, setTextBlockClasses };
